import { Component, Input } from '@angular/core';
import { InputWidget } from '../input-widget';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent extends InputWidget {

  @Input() possibleValues = [
    {
      value: 'Enter Values',
    },
  ];

  constructor() {
    super();
   }

   selectionChange(selectChange){
     this.valueChanged(selectChange.value);
   }
}
